import { OrganizationsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from 'app/queries/types/TCall';
import type { organizationsKeys } from './organizationsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof organizationsKeys.assignableMembers>>;

export const createFetchAssignableMembersQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId, assignable }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        OrganizationsService.getOrgMembers({
          oid: organizationId,
          pageNo: '1',
          pageSize: assignable.pageSize.toString(),
          orderBy: assignable.orderBy,
          orderType: assignable.orderType,
          search: assignable.search,
          teamsSlugFilter: assignable.teamsSlugFilter,
        }),
        signal,
      ),
    );
